import type { ReactNode } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

export const Headings = ({
    main,
    sub
}: {
    main: ReactNode;
    sub?: ReactNode;
}) => (
    <header css={headerCss}>
        <h1 css={[headingCss, mainHeadingCss]}>{main}</h1>
        {sub && <p css={[headingCss, subHeadingCss]}>{sub}</p>}
    </header>
);

const headerCss = css({
    display: "grid",
    gap: token("space.100"),
    hyphens: "auto",
    marginBlockEnd: token("space.200"),
    overflowWrap: "break-word",
    textAlign: "center",
    wordBreak: "break-word"
});

const headingCss = css({
    color: token("color.text"),
    margin: 0
});

const mainHeadingCss = css({
    fontFamily: wacToken("font.charlie.display"),
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 1.25
});

const subHeadingCss = css({
    lineHeight: 1.4
});
